export const translations = (value: string) => {
    if (value === "admin-dealership" || value === "admin dealership") return "admin concesionaria";
    if (value === "admin-branch" || value === "admin branch") return "admin sucursal";
    if (value === "seller") return "vendedor";
    if (value === "final user" || value === "final-user") return "usuario final";
    if (value === "agent") return "agente";
    if (value === "pending") return "pendiente";
    if (value === "accepted") return "aceptado";
    if (value === "rejected") return "rechazado";
    if (value === "cancelled") return "cancelado";
    return "";
};

export const profileTranslations = (profileName: string) => {
    const lowercaseName = profileName.toLowerCase();
    if (lowercaseName === "admin dealership" || lowercaseName === "admin-dealership") return "Administrador concesionaria";
    if (lowercaseName === "admin branch" || lowercaseName === "admin-branch") return "Administrador de sucursal";
    if (lowercaseName === "seller") return "Vendedor";
    if (lowercaseName === "final user" || lowercaseName === "final-user") return "Usuario final";
    if (lowercaseName === "agent") return "Agente";
    if (lowercaseName === "admin") return "Administrador";
    if (lowercaseName === "viewer admin" || lowercaseName === "viewer-admin") return "Administrador visor";
    if (lowercaseName === "admin brand" || lowercaseName === "admin-brand") return "Administrador de marca";
    return profileName; // Si no encuentra traducción, devuelve el original
};

export const prorityTranslations = (priority: string) => {
    if (priority === "high") return "Alta";
    if (priority === "low") return "Baja";
    if (priority === "medium") return "Media";
    if (priority === "normal") return "Media";
    return "";
}